import axios from "axios";
import Swal from "sweetalert2";
import { baseURL, createSession } from "./api_base";
import api from "./api_refresh_token";
import { isObject } from "formik";

axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  "GET, POST, DELETE, PUT"; // definindo o que meu axios pode fazer


//Token
const getToken = () => {
  let token = localStorage.getItem("token");
  return token;
};

export const postSolicitacao = (body) =>
  api
    .post(
      `${baseURL}/solicitacao_servico_store`,
      // url base + rota de busca
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `multipart/form-data`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      //console.log(response);
      Swal.fire({
        icon: "success",
        title: "Solicitação de serviço cadastrada com sucesso",
      });
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

/// buscar id's
export const getSolicitacaoById = (id) =>
  api
    .get(
      `${baseURL}/solicitacoes_servico/${id}`,

      // url base + rota de busca
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

// PUT empresas

export const updateSolicitacao = (id, body, isConcludingOrCanceling) =>
  api
    .post(
      `${baseURL}/solicitacao_servico_update/${id}`,
      // url base + rota de busca
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `multipart/form-data`,
        },
      }
    )
    .then((response) => {
      if (!isConcludingOrCanceling) {
        Swal.fire({
          icon: "success",
          title: "Registro alterado com sucesso",
        });
      }
      // promise ( resposta da requisição )
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

// Delete

export const deleteSolicitacao = (id) =>
  api
    .delete(
      `${baseURL}/solicitacao_servico_delete/${id}`,
      // url base + rota de busca

      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `application/json`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )

      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });
